import { SAVE_INSTANCE, DELETE_INSTANCE, UPDATE_INSTANCE } from '../constants/actions';
import { BaseModel } from '../model/BaseModel';
import { dispatch } from '../utils/generalUtils';

export function saveInstance<P>(instance: BaseModel<P>, key: string, identifier?: string): BaseModel<P> {
    return dispatch({
        type: `${identifier}/${SAVE_INSTANCE}`,
        key,
        instance
    });
}

export function deleteInstance<P>(key: string): BaseModel<P> {
    return dispatch({
        type: DELETE_INSTANCE,
        key
    });
}

export function updateInstance<P>(key: string, instance: BaseModel<P>): BaseModel<P> {
    return dispatch({
        type: UPDATE_INSTANCE,
        instance
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/modelActions.ts